import { useEffect } from 'react';
import type { WorkflowGraph } from '@/graph';
import { useGraphEditorStore } from '@/graph-store';

/**
 * Hook to handle selection expansion for bidirectional highlighting.
 * 
 * The RightPanel.handleStepClicked already handles expanding operation selections to include edges.
 * The graph's native selection handling already provides basic cell selection.
 * This hook is minimal and lets the UI layer handle correspondence.
 */
export function useSelectionExpansion(graph: WorkflowGraph | null) {
  // Currently a no-op since selection expansion is handled by RightPanel
  // Keep as lifecycle hook for consistency
  useEffect(() => {
    // Graph selection changes are synced to store via wireGraphToStore
    // RightPanel handles expanding to related cells on user action
  }, [graph]);
}
